import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { editProfile } from "../../redux/actions/currentProfileActions";
import { useSelector, useDispatch } from "react-redux";
import { CanadianButton } from "../../ui-components/CanadianButton";
import {
  useIonRouter,
  IonInput,
  IonSelect,
  IonSelectOption,
  IonTextarea,
} from "@ionic/react";

const PROVINCES = [
  { code: "AB", name: "Alberta" },
  { code: "BC", name: "British Columbia" },
  { code: "MB", name: "Manitoba" },
  { code: "NB", name: "New Brunswick" },
  { code: "NL", name: "Newfoundland and Labrador" },
  { code: "NS", name: "Nova Scotia" },
  { code: "ON", name: "Ontario" },
  { code: "PE", name: "Prince Edward Island" },
  { code: "QC", name: "Quebec" },
  { code: "SK", name: "Saskatchewan" },
  { code: "NT", name: "Northwest Territories" },
  { code: "NU", name: "Nunavut" },
  { code: "YT", name: "Yukon" },
];

const UpdateProfileForm = () => {
  const { t } = useTranslation();

  const currentProfile = useSelector((state) => state.currentProfile.data);
  const { username } = currentProfile;

  const [formData, setFormData] = useState({
    fname: currentProfile.fname || "",
    lname: currentProfile.lname || "",
    city: currentProfile.city || "",
    province: currentProfile.province || "",
    website: currentProfile.website || "",
    bio: currentProfile.bio || "",
  });

  const router = useIonRouter();
  const dispatch = useDispatch();

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(editProfile(formData));
    router.push(`/profile/${username}`);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="display-flex align-items-c justify-content-c flex-direction-c"
      style={{ gap: "8px", padding: "24px", paddingTop: "24px", width: "100%" }}
    >
      <IonInput
        name="fname"
        placeholder={t("updateProfileForm.firstName")}
        value={formData.fname}
        onIonChange={(e) => handleChange("fname", e.detail.value)}
        fill="outline"
      />
      <IonInput
        name="lname"
        placeholder={t("updateProfileForm.lastName")}
        value={formData.lname}
        onIonChange={(e) => handleChange("lname", e.detail.value)}
        fill="outline"
      />
      <IonInput
        name="city"
        placeholder="City"
        value={formData.city}
        onIonChange={(e) => handleChange("city", e.detail.value)}
        fill="outline"
      />
      <IonSelect
        name="province"
        placeholder="Province / Territory"
        value={formData.province}
        onIonChange={(e) => handleChange("province", e.detail.value)}
        interface="popover"
        fill="outline"
        className="mb-1"
        style={{ width: "100%" }}
      >
        {PROVINCES.map((p) => (
          <IonSelectOption key={p.code} value={p.code}>
            {p.name}
          </IonSelectOption>
        ))}
      </IonSelect>
      <IonInput
        name="website"
        placeholder={t("updateProfileForm.website")}
        // type="url" // Optional: enforce url type if desired
        value={formData.website}
        onIonChange={(e) => handleChange("website", e.detail.value)}
        fill="outline"
      />
      <IonTextarea
        rows={3}
        name="bio"
        placeholder={t("updateProfileForm.bio")}
        value={formData.bio}
        onIonChange={(e) => handleChange("bio", e.detail.value)}
        fill="outline"
      />
      <CanadianButton type="submit">
        {t("updateProfileForm.save")}
      </CanadianButton>
    </form>
  );
};

export default UpdateProfileForm;

